/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import clsx from "clsx";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { useDispatch, useSelector } from "react-redux";
import { useParams, NavLink } from "react-router-dom";
import { UnitMeasurementTable } from "./UnitMeasurementTable";
import { emptyValidation, customAlaphaNumericOnlyValidation, customDecimalValidation } from "../../../../../helpers/validation";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const UnitMesurement = (props) => {
    const [visible, setVisible] = useState(false);
    const { unitClassdetails, unitMesurementdetails, loader } = useSelector(state => state.productSetupReducer);
    const { createDetails, createError, createLoader, getList, getData, getLoader } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleType } = props;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [classId, setClassId] = useState('');
    const [addMore, setAddMore] = useState(false);
    const [filterClassId, setFilterClassId] = useState('');
    const [systemOfUnits, setSystemOfUnits] = useState('');
    const [precision, setPrecision] = useState('');
    const [search, setSearch] = useState('');
    const [errorPrecision, setErrorPrecision] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorClass, setErrorClass] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const { filterParamsClassId } = useParams();
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [importVisible, setImportVisible] = useState(false);

    let menus = [
        {
            "name": "Unit Class",
            "link": `${moduleType === 'Admin' ? '/admin' : '/younote-admin'}/setup/units/unit-class`
        },
        {
            "name": "Unit Conversion",
            "link": `${moduleType === 'Admin' ? '/admin' : '/younote-admin'}/setup/units/unit-conversions`
        },
        {
            "name": "Product Unit Conversion",
            "link": "/product/setup/units/product-unit-conversions"
        }
    ];

    const dispatch = useDispatch();

    const handleOpen = () => {
        setVisible(true);
    };

    const emptyState = () => {
        setErrorName(false);
        setErrorClass(false);
        setErrorPrecision(false);
    };

    const emptyStateInput = () => {
        setName('');
        setClassId('');
    };

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(filterClassId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(filterClassId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        // if (roleManagement !== '' && checkViewPermission('Unit of Measurement', history, 'Younote Admin')) {
        loadTasks();
        // }
    }, []);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (filterClassId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { "and": [] };
        let or = { "or": [] };
        if (filterClassId !== '') {
            filter['and'].push({ unitClassId: filterClassId });
        }
        if (search !== '') {
            or['or'].push({ name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ systemOfUnits: { like: '%' + search.trim() + '%' } });
            or['or'].push({ precision: { like: '%' + search.trim() + '%' } });
        }
        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'unit',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            },
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.UNITCLASS_DETAILS_START, url: 'unitclass', filter: {
                order: 'id  desc'
            }
        });
        if (filterParamsClassId !== undefined) {
            setFilterClassId(filterParamsClassId);
        }

        dispatchFilter(filterParamsClassId, sortBy, sortOrder);
        setTimeout(function () {
            dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, component: "Unit of Measurement" });
        }, 200)
    });

    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const addMeasurement = (e) => {
        e.preventDefault();
        let emptyName = customAlaphaNumericOnlyValidation('Unit', name);
        let emptyClass = emptyValidation('Unit Class', classId, 'dropDown');
        let emptyDescimal = customDecimalValidation('Decimal Precision', precision)
        emptyState();
        if (emptyName.isValid && emptyClass.isValid && emptyDescimal.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'unit',
                title: 'Unit',
                details: {
                    name: name,
                    description: description,
                    unitClassId: classId,
                    systemOfUnits: systemOfUnits,
                    precision: precision ? parseInt(precision) : 0
                }
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyClass.errors) {
                setErrorClass(emptyClass.errors);
            }
            if (emptyDescimal.errors) {
                setErrorPrecision(emptyDescimal.errors);
            }

        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            handleUnitClassId(filterClassId);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorName(error);
        }
    }, [createDetails, createError]);

    const handleAddMore = (e) => {
        addMeasurement(e);
        setAddMore(true);
    }

    const handleUnitClassId = (value) => {
        setFilterClassId(value);
        dispatchFilter(value, sortBy, sortOrder);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(filterClassId, sortBy, sortOrder);
    }

    const [iconAnimation, setIconAnimation] = useState(false);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(filterClassId, sortBy, sortOrder, s);
    }

    const onExport = () => {
        loadImportExportData('Unit of Measurement');
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.UNITMESUREMENT_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'unit',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const handleClick = (value) => {
        menus = [
            {
                "name": "Unit Class",
                "link": "/younote-admin/setup/units/unit-class"
            },
            {
                "name": "Unit Conversion",
                "link": `/younote-admin/setup/units/${value}/unit-conversions`
            },
            {
                "name": "Product Unit Conversion",
                "link": `/product/setup/units/${value}/product-unit-conversions`
            }
        ];
        dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true });
    }

    const onImport = () => {
        setImportVisible(true);
    }

    const onImportClose = () => {
        setImportVisible(false);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            {
                moduleType === 'Admin' ? <MainHeader {...props} img={SettingsImg} title={'Admin'}
                    links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Units', 'link': '' }]} /> : <MainHeader {...props} img={SettingsImg} title={'Younote Admin'}
                        links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Units', 'link': '' }]} />
            }
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Unit of Measurement '}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Unit of Measurement', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.customerLabelNone, classes.removeUnderline, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit of Measurement', 'Action', 'All Dropdown') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={unitClassdetails}
                                                    parentValue={customObject(unitClassdetails, filterClassId)}
                                                    customClasses={clsx(classes.customWidth172P, classes.customFilterNone)}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleUnitClassId('')
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        handleUnitClassId(data.id)
                                                    }}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit of Measurement', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit of Measurement', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => onImport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('Unit of Measurement', 'create', 'Younote Admin') || checkCRUDPermission('Unit of Measurement', 'create', 'Admin')) &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink, classes.disInline, classes.cursor)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Unit</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Unit of Measurement', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <UnitMeasurementTable
                                details={getList}
                                loader={getLoader}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                rowClick={(value) => handleClick(value)}
                                unitClassdetails={unitClassdetails}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                handleUnitClassId={() => handleUnitClassId(filterClassId)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Add Unit'}
                width={"495px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => addMeasurement(e)}
                    >
                        <Row gutter={40}>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} >
                                <TextField autoComplete='one-time-code'
                                    label={["Unit ", <span key={'Unit'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    fullWidth
                                    error={errorName ? true : false}
                                    helperText={errorName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <AutoCompleteComponent
                                    name={["Unit Class ", <span key={'Unit Class'} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={unitClassdetails}
                                    customClasses={classes.marginTop20}
                                    parentValue={customObject(unitClassdetails, classId)}
                                    onChange={(data) => setClassId(data.id)}
                                    position={"bottom"}
                                    parentError={errorClass}
                                />
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <TextField autoComplete='one-time-code'
                                    type="number"
                                    label='Decimal Precision'
                                    error={errorPrecision && true}
                                    helperText={errorPrecision}
                                    variant={'standard'}
                                    max={6}
                                    fullWidth
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        },
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setPrecision(e.target.value)}
                                />
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <TextField autoComplete='one-time-code'
                                    label='Description'
                                    variant={'standard'}
                                    fullWidth
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <AutoCompleteComponent
                                    name={["System of Units"]}
                                    heads={[{ 'key': 'label', 'name': 'Label' }]}
                                    details={[{ label: 'Metric system', id: 'Metric system' }, { label: 'Imperial system', id: 'Imperial system' }]}
                                    parentValue={customObject([{ label: 'Metric system', id: 'Metric system' }, { label: 'Imperial system', id: 'Imperial system' }], systemOfUnits)}
                                    onChange={(data) => setSystemOfUnits(data.id)}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                />
                            </Col>
                        </Row>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                    Save & Close
                                </Button><Button
                                    key="add"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                    onClick={(e) => handleAddMore(e)}
                                >
                                    Add More
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ImportExport
                handleClose={() => onImportClose()}
                visible={importVisible}
                title={'Unit of Measurement'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={unitMesurementdetails}
                loadTasks={() => { dispatchFilter(filterClassId, sortBy, sortOrder) }}
            />
            <QuickLinks menus={menus} component={"Unit of Measurement"}></QuickLinks>
        </React.Fragment>
    )
}
export default UnitMesurement